import { useState } from 'react'

import { getAuthToken } from './helpers'
import { LoginUrls, LoginUrlsStageMap, StageDisplayNamesMap } from './constants'

function AuthForm(props) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loginUrl, setLoginUrl] = useState(LoginUrls.STAGE)
  const [authToken, setAuthToken] = useState('')
  const [loggingIn, setLoggingIn] = useState(false)

  function resetAuth() {
    setAuthToken(null)
    props.onAuthTokenChange(null)
  }

  function handleUsernameChange(e) {
    setUsername(e.target.value)
    resetAuth()
  }

  function handlePasswordChange(e) {
    setPassword(e.target.value)
    resetAuth()
  }

  function handleLoginUrlChange(e) {
    setLoginUrl(e.target.value)
    resetAuth()
  }

  async function handleGetAuthToken() {
    setLoggingIn(true)
    const authToken = await getAuthToken({
      username,
      password,
      loginUrl,
      stage: props.stage,
    })
    setAuthToken(authToken)
    props.onAuthTokenChange(authToken)
    setLoggingIn(false)
  }

  return (
    <section className="authorization">
      <section className="auth-form">
        <span>Username:</span>
        <input type="text" value={username} onChange={handleUsernameChange} />
        <span>Password:</span>
        <input
          type="password"
          value={password}
          onChange={handlePasswordChange}
        />
        <span>Login URL:</span>
        <select value={loginUrl} onChange={handleLoginUrlChange}>
          <option value={LoginUrls.STAGE}>
            Stage/Dev Login Endpoint: {LoginUrls.STAGE}
          </option>
          <option value={LoginUrls.PROD}>
            Prod Login Endpoint: {LoginUrls.PROD}
          </option>
        </select>
        <button onClick={handleGetAuthToken} disabled={loggingIn}>
          Login
        </button>
      </section>
      {loggingIn && <section className="auth-result">Logging In...</section>}
      {authToken && !loggingIn && (
        <section className="auth-result">
          Logged In to {StageDisplayNamesMap[LoginUrlsStageMap[loginUrl]]}!
        </section>
      )}
      {!authToken && !loggingIn && (
        <section className="auth-result">Not Logged In</section>
      )}
    </section>
  )
}

export default AuthForm
